import React from 'react';

import { searchAdGroupCreationStepConfigs } from '../steps/step-configs';
import { AD_GROUP_TYPES, getAdGroupCreationStepListConfig, getSearchAdGroupCreationFlow, SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS } from '../steps/step-utils';
import { CreationWizard } from './creation-wizard';

export const SearchAdGroupCreationWizard = props => (
  <CreationWizard
    stepConfigs={searchAdGroupCreationStepConfigs}
    getStepListConfig={getAdGroupCreationStepListConfig}
    scenarioName="SearchAdGroupCreationRevamp"
    activityName="SearchAdGroupWizard"
    wizardLoggerFlowName="SearchAdGroup"
    wizardLoggerSubFlowName="SearchAdGroupCreation"
    wizardLoggerStepToPage={SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS}
    perfMarkerName="SearchAdGroupCreationWizard"
    onDoneNavigateToSiteMapId="adgroups"
    initialFlowFactors={{
      adGroupType: AD_GROUP_TYPES.SearchStandard,
    }}
    getFlow={getSearchAdGroupCreationFlow}
    {...props}
  />
);
